import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-blue-bottom",
  "use": "icon-blue-bottom-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-blue-bottom\">\n<path d=\"M11.7178 3.86367L6.60489 9.45469C6.45255 9.62812 6.23223 9.72773 6.0002 9.72773C5.76934 9.72773 5.54903 9.62812 5.39551 9.45469L0.282623 3.86367C0.0330134 3.6 -0.0443303 3.21563 0.0857478 2.87578C0.215826 2.53594 0.526373 2.29922 0.888482 2.26758H11.1096C11.4729 2.29805 11.7857 2.53359 11.9147 2.87461C12.0447 3.21563 11.9674 3.59766 11.7178 3.86367Z\" fill=\"#1677FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol